import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Join from "./pages/Join/Join";
import OfficeJoin from "./pages/Join/OfficeJoin";
import UserJoin from "./pages/Join/UserJoin";
import UserJoinPrivate from "./pages/Join/UserJoinPrivate";
import UserJoinContact from "./pages/Join/UserJoinContact";
import UserJoinAddress from "./pages/Join/UserJoinAddress";
import UserJoinPhysical from "./pages/Join/UserJoinPhysical";
import FindId from "./pages/Join/FindId";
import FindPassword from "./pages/Join/FindPassword";
import JoinAgree from "./pages/Join/JoinAgree";

import Reservation from "./pages/Reservation";
import ReservationStep from "./pages/reservation/ReservationStep";
import SetFinishDetail from "./pages/reservation/SetFinishDetail";
import SetPayValidation from "./pages/reservation/SetPayValidation";

import ReservationCounsel from "./pages/ReservationCounsel";
import ReservationCounselStep from "./pages/reservation/ReservationCounselStep";

import Check from "./pages/Check";
import SelfStart from "./pages/check/SelfStart";
import CheckStep from "./pages/check/CheckStep";
import SelfScore from "./pages/check/SelfScore";
import SelfScoreSimple from "./pages/check/SelfScoreSimple";
import SelfCheckList from "./pages/check/SelfCheckList";
import Counsel from "./pages/check/Counsel";
import CreateCounsel from "./pages/check/CreateCounsel";


import Care from "./pages/Care";
import CareStep from "./pages/care/CareStep";
import CareMenu from "./pages/care/CareMenu";
import CareSports from "./pages/care/CareSports";

import HealthNews from "./pages/News/HealthNews";

import History from "./pages/History";
import HistoryBurnKcal from "./pages/History/HistoryBurnKcal";
import HistoryEatFood from "./pages/History/HistoryEatFood";
import HistoryDrinkWater from "./pages/History/HistoryDrinkWater";
import HistoryWalking from "./pages/History/HistoryWalking";
import MonthHistory from "./pages/History/MonthHistory";
import HistoryFoodInput from "./components/HistoryFoodInput";
import HistorySportsInput from "./components/HistorySportsInput";
import HistoryPressure from "./pages/History/HistoryPressure";
import PressureMonthHistory from "./pages/History/PressureMonthHistory";
import HistoryBlood from "./pages/History/HistoryBlood";
import BloodMonthHistory from "./pages/History/BloodMonthHistory";
import HistoryWeight from "./pages/History/HistoryWeight";
import WeightMonthHistory from "./pages/History/WeightMonthHistory";
import HistoryDevice from "./pages/History/HistoryDevice";
import HistoryDeviceDetail from "./pages/History/HistoryDeviceDetail";
import HistoryDeviceMonthHistory from "./pages/History/HistoryDeviceMonthHistory";

import MoreMenu from "./pages/MoreMenu";

import Notice from "./pages/Notice/Notice";
import Support from "./pages/Notice/Support";


import Terms from "./pages/Policy/Terms";
import Private from "./pages/Policy/Private";
import UsePolicy from "./pages/Policy/UsePolicy";
import Collect from './pages/Policy/Collect';
import Third from './pages/Policy/Third';
import Ads from './pages/Policy/Ads';

import Version from "./pages/Version/Version";

import MyPage from "./pages/MyPage/MyPage";
import ReservationView from "./pages/MyPage/ReservationView";
import HealthResult from "./pages/MyPage/HealthResult";
import HealthResultCompare from "./pages/MyPage/HealthResultCompare";
import GeneticResult from "./pages/MyPage/GeneticResult";

import ScrollToTop from "./pages/ScrollToTop";
import RequireLogin from "./components/RequireLogin";
import { RouteErrorBoundary } from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import ReservationBeforeView from "./pages/MyPage/ReservationBeforeView";
import Stress from "./pages/survey/stress/Stress";
import StressMain from "./pages/survey/stress/StressMain";
import StressAnswer from "./pages/survey/stress/StressAnswer";
import StressResult from "./pages/survey/stress/StressResult";
import Hra from "./pages/survey/hra/Hra";
import HraAnswer from "./pages/survey/hra/HraAnswer";
import HraResult from "./pages/survey/hra/HraResult";
import SupportQuestion from "./pages/Notice/SupportQuestion";
import SupportCreateQuestion from "./pages/Notice/SupportCreateQuestion";
import SupportDetailQuestion from "./pages/Notice/SupportDetailQuestion";
import OfficeJoinPrivate from "./pages/Join/OfficeJoinPrivate";
import OfficeJoinContact from "./pages/Join/OfficeJoinContact";
import OfficeJoinAddress from "./pages/Join/OfficeJoinAddress";
import OfficeJoinCompanyCheck from "./pages/Join/OfficeJoinCompanyCheck";
import Event from "./pages/Notice/Event";
import Modeling from "./pages/DigitalTwin/Modeling";
import ModelingDetail from "./pages/DigitalTwin/ModelingDetail";
import DigitalTwinScreen2 from "./pages/DigitalTwin/DigitalTwinScreen2";
import DigitalTwinScreen3 from "./pages/DigitalTwin/DigitalTwinScreen3";
import DigitalTwinScreen5 from "./pages/DigitalTwin/DigitalTwinScreen5";



const App = () => {
  return (
    <Router>
      <ScrollToTop />
      {/* 렌더 중 예외가 나도 앱 전체가 흰 화면이 되지 않도록 감싼다.
          (이벤트 핸들러·Promise 안의 예외는 잡지 못한다 — ErrorBoundary 주석 참고) */}
      <RouteErrorBoundary>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/reservation/ReservationStep" element={<ReservationStep />} />
        <Route path="/reservation/SetFinishDetail" element={<SetFinishDetail />} />
        <Route path="/reservation/SetPayValidation" element={<SetPayValidation />} />
        
        <Route path="/reservationCounsel" element={<ReservationCounsel />} />
        <Route path="/reservation/ReservationCounselStep" element={<ReservationCounselStep />} />

        <Route path="/check" element={<Check />} />
        <Route path="/check/SelfStart" element={<SelfStart />} />
        <Route path="/check/CheckStep" element={<CheckStep />} />
        <Route path="/check/SelfScore" element={<SelfScore />} />
        <Route path="/check/SelfScoreSimple" element={<SelfScoreSimple />} />
        <Route path="/check/SelfCheckList" element={<SelfCheckList />} />

        <Route path="/check/Counsel" element={<RequireLogin><Counsel /></RequireLogin>} />
        <Route path="/check/CreateCounsel" element={<RequireLogin><CreateCounsel /></RequireLogin>} />

        <Route path="/care" element={<Care />} />
        <Route path="/care/careStep" element={<CareStep />} />
        <Route path="/care/CareMenu" element={<CareMenu />} />
        <Route path="/care/CareSports" element={<CareSports />} />

        <Route path="/News/HealthNews" element={<HealthNews />} />

        <Route path="/history" element={<History />} />
        <Route path="/history/burn" element={<HistoryBurnKcal />} />
        <Route path="/history/eat" element={<HistoryEatFood />} />
        <Route path="/history/drink" element={<HistoryDrinkWater />} />
        <Route path="/history/walking" element={<HistoryWalking />} />
        <Route path="/history/MonthHistory" element={<MonthHistory />} />
        <Route path="/history/HistoryFoodInput" element={<HistoryFoodInput />} />
        <Route path="/history/HistorySportsInput" element={<HistorySportsInput />} />
        <Route path="/history/pressure" element={<HistoryPressure />} />
        <Route path="/history/PressureMonthHistory" element={<PressureMonthHistory />} />
        <Route path="/history/Blood" element={<HistoryBlood />} />
        <Route path="/history/BloodMonthHistory" element={<BloodMonthHistory />} />
        <Route path="/history/HistoryWeight" element={<HistoryWeight />} />
        <Route path="/history/WeightMonthHistory" element={<WeightMonthHistory />} />
        <Route path="/history/HistoryDevice" element={<HistoryDevice />} />
        <Route path="/history/HistoryDeviceDetail" element={<HistoryDeviceDetail />} />
        <Route path="/history/HistoryDeviceMonthHistory" element={<HistoryDeviceMonthHistory />} />

        <Route path="/MoreMenu" element={<MoreMenu />} />

        <Route path="/Notice/Notice" element={<Notice />} />
        <Route path="/Notice/Support" element={<Support />} />
        <Route path="/Notice/SupportQuestion" element={<SupportQuestion />} />
        <Route path="/Notice/SupportCreateQuestion" element={<SupportCreateQuestion />} />
        <Route path="/Notice/SupportDetailQuestion" element={<SupportDetailQuestion />} />
        <Route path="/Notice/Event" element={<Event />} />

        <Route path="/Policy/Terms" element={<Terms />} />
        <Route path="/Policy/Private" element={<Private />} />
        <Route path="/Policy/UsePolicy" element={<UsePolicy />} />
        <Route path="/Policy/Collect" element={<Collect />} />
        <Route path="/Policy/Third" element={<Third />} />
        <Route path="/Policy/Ads" element={<Ads />} />

        <Route path="/Version/Version" element={<Version />} />

        <Route path="/MyPage/MyPage" element={<RequireLogin><MyPage /></RequireLogin>} />
        <Route path="/MyPage/ReservationView" element={<RequireLogin><ReservationView /></RequireLogin>} />
        <Route path="/MyPage/ReservationBeforeView" element={<RequireLogin><ReservationBeforeView /></RequireLogin>} />
        <Route path="/MyPage/HealthResult" element={<RequireLogin><HealthResult /></RequireLogin>} />
        <Route path="/MyPage/HealthResultCompare" element={<RequireLogin><HealthResultCompare /></RequireLogin>} />
        <Route path="/MyPage/GeneticResult" element={<RequireLogin><GeneticResult /></RequireLogin>} />


        <Route path="/login" element={<Login />} />
        <Route path="/Join/Join" element={<Join />} />
        <Route path="/Join/OfficeJoin/redirect/GET" element={<OfficeJoin />} />
        <Route path="/Join/OfficeJoinCompanyCheck" element={<OfficeJoinCompanyCheck />} />
        <Route path="/Join/OfficeJoinPrivate" element={<OfficeJoinPrivate />} />
        <Route path="/Join/OfficeJoinContact" element={<OfficeJoinContact />} />
        <Route path="/Join/OfficeJoinAddress" element={<OfficeJoinAddress />} />
        <Route path="/Join/UserJoin/redirect/GET" element={<UserJoin />} />
        <Route path="/Join/UserJoinPrivate" element={<UserJoinPrivate />} />
        <Route path="/Join/UserJoinContact" element={<UserJoinContact />} />
        <Route path="/Join/UserJoinAddress" element={<UserJoinAddress />} />
        <Route path="/Join/UserJoinPhysical" element={<UserJoinPhysical />} />
        <Route path="/Join/FindId" element={<FindId />} />
        <Route path="/Join/FindPassword" element={<FindPassword />} />
        <Route path="/Join/JoinAgree" element={<JoinAgree />} />

        <Route path="/survey/stress" element={<RequireLogin><Stress /></RequireLogin>} />
        <Route path="/survey/stress/main" element={<RequireLogin><StressMain /></RequireLogin>} />
        <Route path="/survey/stress/answer" element={<RequireLogin><StressAnswer /></RequireLogin>} />
        <Route path="/survey/stress/result" element={<RequireLogin><StressResult /></RequireLogin>} />

        <Route path="/survey/hra" element={<RequireLogin><Hra /></RequireLogin>} />
        <Route path="/survey/hra/answer" element={<RequireLogin><HraAnswer /></RequireLogin>} />
        <Route path="/survey/hra/result" element={<RequireLogin><HraResult /></RequireLogin>} />

        {/* 디지털 트윈 — 모두 로그인 정보(ownerFamID)로 AP_009_002 를 조회하므로 가드가 필요하다 */}
        <Route path="/digitalTwin/modeling" element={<RequireLogin><Modeling /></RequireLogin>} />
        <Route path="/digitalTwin/screen1" element={<RequireLogin><Modeling /></RequireLogin>} />
        <Route path="/digitalTwin/screen2" element={<RequireLogin><DigitalTwinScreen2 /></RequireLogin>} />
        <Route path="/digitalTwin/screen3" element={<RequireLogin><DigitalTwinScreen3 /></RequireLogin>} />
        <Route path="/digitalTwin/screen5" element={<RequireLogin><DigitalTwinScreen5 /></RequireLogin>} />
        <Route path="/digitalTwin/ModelingDetail" element={<RequireLogin><ModelingDetail /></RequireLogin>} />

        {/* 등록되지 않은 주소 — serve -s 가 200 + index.html 을 주므로
            이 폴백이 없으면 아무것도 렌더되지 않은 빈 페이지가 된다.
            react-router v6 는 순서가 아니라 구체성으로 매칭하므로 위 라우트들이 우선한다. */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      </RouteErrorBoundary>
    </Router>
  );
}
export default App;